import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from '../../../../../../api'

export const happyfoxHelpdeskApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'happyfoxHelpdeskApi',
  tagTypes: ['HappyFoxHelpdesk'],
  refetchOnMountOrArgChange: 5,
  endpoints: (builder) => ({
    getApp: builder.query({
      query: () => '/v1/apps/happyfox-helpdesk',
      providesTags: ['HappyFoxHelpdesk']
    }),
    authorize: builder.mutation({
      query: (data) => {
        return {
          url: '/v1/apps/happyfox-helpdesk/authorize',
          method: 'POST',
          body: data
        }
      },
      invalidatesTags: ['HappyFoxHelpdesk']
    }),
    uninstall: builder.mutation({
      query: () => {
        return {
          url: '/v1/apps/happyfox-helpdesk',
          method: 'DELETE'
        }
      },
      invalidatesTags: ['HappyFoxHelpdesk']
    }),
    update: builder.mutation({
      query: (data) => {
        return {
          url: '/v1/apps/happyfox-helpdesk',
          method: 'PATCH',
          body: data
        }
      },
      invalidatesTags: ['HappyFoxHelpdesk']
    })
  })
})

export const { useGetAppQuery, useAuthorizeMutation, useUninstallMutation, useUpdateMutation } = happyfoxHelpdeskApi

export default happyfoxHelpdeskApi
